import consent from "ms.consent";
import Log from "app/utils/log";

const log = new Log("ConsentService");

interface ConsentResult {
    tcfVersion: number,
    gdpr: "0" | "1",
    consentString: string,
    usPrivacy: string,
    isPersonalizedAdAllowed: boolean
}

function isPersonalizedAdAllowed(): boolean {
    try {
        return consent.padAllowed();
    } catch (error) {
        log.info("Error getting padAllowed info");
        return false;
    }
}

export async function fetchParams(): Promise<ConsentResult> {
    try {
        await consent.waitForUserConsent();
    } catch (e) {
        log.error("Error waiting for user consent in fetchParamsV2: ", e);
        return {
            tcfVersion: 2,
            gdpr: "1",
            consentString: "",
            usPrivacy: "",
            isPersonalizedAdAllowed: false
        };
    }

    return {
        tcfVersion: 2,
        gdpr: await (consent.gdprAppliesAsync().catch(() => true)) ? "1" : "0",
        consentString: await (consent.iabConsentStringAsync().catch(() => "")),
        usPrivacy: await (consent.getUSPrivacyStringAsync().catch(() => "")),
        isPersonalizedAdAllowed: isPersonalizedAdAllowed()
    };
}
